import { SAVE_KEY } from '../config.js';

const DEFAULT = {
  bestWave: 0,
  bestScore: 0,
  totalKills: 0,
  totalCorrect: 0,
  totalWrong: 0,
  bestCombo: 0,
  bossDefeated: false,
  basicCompleted: false,
  advancedCompleted: false,
  expertCompleted: false,
  audioEnabled: true,
  lastPlayed: null,
};

export const SaveSystem = {
  load() {
    try {
      const raw = localStorage.getItem(SAVE_KEY);
      if (!raw) return { ...DEFAULT };
      const parsed = JSON.parse(raw);
      return { ...DEFAULT, ...parsed };
    } catch {
      return { ...DEFAULT };
    }
  },

  save(data) {
    try {
      const merged = { ...this.load(), ...data, lastPlayed: new Date().toISOString() };
      localStorage.setItem(SAVE_KEY, JSON.stringify(merged));
      return merged;
    } catch {
      return null;
    }
  },

  recordRun(stats) {
    const cur = this.load();
    const next = {
      bestWave: Math.max(cur.bestWave, stats.waveReached || 0),
      bestScore: Math.max(cur.bestScore, stats.score || 0),
      bestCombo: Math.max(cur.bestCombo, stats.bestCombo || 0),
      totalKills: cur.totalKills + (stats.kills || 0),
      totalCorrect: cur.totalCorrect + (stats.correct || 0),
      totalWrong: cur.totalWrong + (stats.wrong || 0),
      bossDefeated: cur.bossDefeated || !!stats.bossDefeated,
      basicCompleted: cur.basicCompleted || !!stats.basicCompleted,
      advancedCompleted: cur.advancedCompleted || !!stats.advancedCompleted,
      expertCompleted: cur.expertCompleted || !!stats.expertCompleted,
    };
    return this.save(next);
  },

  isAdvancedUnlocked() {
    return !!this.load().basicCompleted;
  },

  isExpertUnlocked() {
    return !!this.load().advancedCompleted;
  },

  setAudioEnabled(on) {
    return this.save({ audioEnabled: !!on });
  },

  reset() {
    try {
      localStorage.removeItem(SAVE_KEY);
    } catch {}
  },
};
